class AuthenticateUser {
    constructor(store) {
      this.store = store;
    }
  
    /**
     * Authenticates user.
     */
    handle(to, from, next) {
      const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
  
      if (requiresAuth && !this.store.getters["auth/authenticated"]) {
        return next({
          name: "login",
          query: { redirect: to.query.redirect || to.fullPath }
        });
      }
  
      next();
    }
  }
  
  export default AuthenticateUser;
  